module.exports = __webpack_public_path__ + "img/icon2.4c684cd1.png";